
    import './styles.scoped.css';
    export default {
  "progress": "awsui_progress_11huc_1mp9s_185",
  "result-state": "awsui_result-state_11huc_1mp9s_199",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_11huc_1mp9s_1",
  "root": "awsui_root_11huc_1mp9s_221",
  "with-result-button": "awsui_with-result-button_11huc_1mp9s_256",
  "result-text": "awsui_result-text_11huc_1mp9s_260",
  "result-container-error": "awsui_result-container-error_11huc_1mp9s_264",
  "result-container-success": "awsui_result-container-success_11huc_1mp9s_264",
  "result-button": "awsui_result-button_11huc_1mp9s_268",
  "word-wrap": "awsui_word-wrap_11huc_1mp9s_273",
  "label-flash": "awsui_label-flash_11huc_1mp9s_278",
  "label-key-value": "awsui_label-key-value_11huc_1mp9s_282",
  "flash": "awsui_flash_11huc_1mp9s_290",
  "progress-container": "awsui_progress-container_11huc_1mp9s_294",
  "percentage-container": "awsui_percentage-container_11huc_1mp9s_301",
  "percentage": "awsui_percentage_11huc_1mp9s_301",
  "complete": "awsui_complete_11huc_1mp9s_336",
  "progress-in-flash": "awsui_progress-in-flash_11huc_1mp9s_351"
};
  